export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
            关于我们
          </h2>
          <div className="mt-8 md:mt-10 p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/60">
            <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed">
              <p className="text-sm md:text-base">
                91免费视频网站成立于国内在线视频蓬勃发展的时代，是一家专注于国产免费视频内容聚合与分发的在线平台。我们致力于为广大观众提供最全面、最优质的<strong>91国产免费视频</strong>和<strong>91传媒视频在线</strong>资源，涵盖剧情短片、高清合集、经典回顾、轻松小视频等多种类型。
              </p>
              <p className="mt-4 text-sm md:text-base">
                平台每日由专业编辑团队筛选50部以上优质国产影片入库，确保内容持续更新。我们采用先进的视频编码与CDN加速技术，实现<strong>国产高清视频免费</strong>在线观看不缓冲的流畅体验。无论您使用电脑、平板还是手机，都能随时随地畅享<strong>国产视频在线观看免费</strong>服务。
              </p>
              <p className="mt-4 text-sm md:text-base">
                91免费视频网站始终秉持"让好内容被更多人看到"的理念，欢迎优质国产视频创作者与内容方与我们合作。我们为合作伙伴提供海量曝光机会与专业的内容分发支持，共同推动国产视频内容的繁荣发展。
              </p>
            </div>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {[
                { num: '5000+', label: '国产影片资源' },
                { num: '50+/日', label: '每日更新数量' },
                { num: '300万+', label: '月活跃观众' },
                { num: '4年', label: '稳定运营时长' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-3 rounded-lg bg-background-50">
                  <p className="text-lg md:text-xl font-bold text-primary-500">{stat.num}</p>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}